import { jsx } from "react/jsx-runtime";
import "react";
import { ChatbotDataProvider } from "./ChatbotDataProvider.js";
import { ChatMessagesProvider } from "./ChatMessagesProvider.js";
import { LoadingStateProvider } from "./LoadingStateProvider.js";
import { ChatUIContextProvider } from "./ChatUIContextProvider.js";
import { RealTimeProvider } from "./RealTimeProvider.js";
const ChatProvider = ({ children, chatbotData, chatMessages, loadingState, ui, realtime })=>/*#__PURE__*/ jsx(ChatbotDataProvider, {
        ...chatbotData,
        children: /*#__PURE__*/ jsx(ChatMessagesProvider, {
            value: chatMessages,
            children: /*#__PURE__*/ jsx(LoadingStateProvider, {
                value: loadingState,
                children: /*#__PURE__*/ jsx(ChatUIContextProvider, {
                    value: ui,
                    children: /*#__PURE__*/ jsx(RealTimeProvider, {
                        value: realtime,
                        children: children
                    })
                })
            })
        })
    });
export { ChatProvider };
